import React from 'react';
import {LegendCategory, LegendMarker, LegendPercent, LegendRow, LegendValue} from './styles';

export type LegendRowData = {
    color: string;
    name: string;
    valueLabel: string;
    percentLabel: string;
    i: number;
};

type Props = {
    row: LegendRowData;
    onClick: (i: number) => void;
    onHover: (i: number) => void;
    onLeave: (i: number) => void;
};

const LegendItem: React.FC<Props> = ({ row, onClick, onHover, onLeave }) => {
    const { i, color, name, valueLabel, percentLabel } = row;
    console.log(row)

    return (
        <LegendRow
            role="button"
            tabIndex={0}
            onClick={() => onClick(i)}
            onMouseOver={() => onHover(i)}
            onMouseLeave={() => onLeave(i)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onClick(i);
            }}
        >
            <LegendMarker style={{ backgroundColor: color }} />
            <LegendCategory>{name}</LegendCategory>
            <LegendValue>{valueLabel}</LegendValue>
            <LegendPercent>{percentLabel}</LegendPercent>
        </LegendRow>
    );
};

export default LegendItem;